import Action from '../Action'
// import './styles/ModalCreateTech.css'
import { useState ,useEffect} from 'react';
import LoadSimple from '../LoadSimple';
import InputAdmin from '../InputAdmin';
import { useFetch } from '../../hooks/useFetch';
import SelectorAdmin from '../SelectorAdmin';
import { lang } from "../generales/traduction";
import { capitalizeFirstLetter } from "../../utils/utils";
const ModalCreateTech =({user,languaje,server,setRegisterIsValid,dataCisConf,ServiceSelected,dataTech,setDataTech,setData,loading,setLoading,setError,setEditActive,editActive,closCreateTechModal})=>{
    const obtenerFechaActualLocal = () => {
        const ahora = new Date();
        const anio = ahora.getFullYear();
        const mes = String(ahora.getMonth() + 1).padStart(2, '0'); // El mes se cuenta desde 0
        const dia = String(ahora.getDate()).padStart(2, '0');
        const horas = String(ahora.getHours()).padStart(2, '0');
        const minutos = String(ahora.getMinutes()).padStart(2, '0');
      
        return `${anio}-${mes}-${dia}T${horas}:${minutos}`;
      };
      const dataCriticalities=useFetch('cassia/criticalities','','','GET',server)
    const [loadingM,setLoadingM]=useState(false);
    const [IpValid,setIpValid]=useState(true)
    const [matchPassword,setMatchPassword]=useState(false)
    const [disabled,setDisabled]=useState(true)
    const [host,sethost]=useState([])
    
    const  techActual = dataCisConf.data.techs.map(obj => obj.tech_name);
    const [ManttoData,setManttoData]=useState({service_id:ServiceSelected.cassia_tech_service_id,tech_name:(editActive)?dataTech.tech_name:"",cassia_criticality_id:(editActive)?dataTech.cassia_criticality_id:0,tech_description:(editActive)?dataTech.tech_description:"",sla_hours:(editActive)?dataTech.sla_hours:0})
    const [hostName,setHostName]=useState("") 
    const [hostLocation,setHostLocation]=useState("") 
    const [hostActivate,setHostActivate]=useState(0)
    
    // const tec_list=useFetch('cassia/ci_elements/technologies','','','GET',server)
    const [msgError,setMsgError]=useState(lang[languaje]['msgTecnologiaExiste'])
    const [listSearchIP,setListSearchIP]=useState(false)
    
        useEffect(()=>{
        
           if(host.length>=1){
            
            setHostName(host[0].name)
           
           
           }else{
         
            setHostName("")
            
           }
      },[host])
      
    const handleChange=(e)=>{
        
        const {name,value}=e.target
       
        if(e.target.name==="tech_name"){
            if(techActual.includes(value)){
                if(editActive && value==dataTech.tech_name){
                    setIpValid(true)
                }else{
                    setMsgError(lang[languaje]['msgTecnologiaExiste'])
                    setIpValid(false)
                    
                }
               
            }else{
                
                setIpValid(true)
            }
            setManttoData((prevState)=>{
                return {
                    ...prevState,
                    [name]:value
                }
                
            })
        } else if(e.target.name==="sla_hours"){
          
            if( (!isNaN(value) && !isNaN(parseFloat(value)))|| value==""){
                
                setManttoData((prevState)=>{
                    return {
                        ...prevState,
                        [name]:value===""?'':(parseInt(value))
                    }
                    
                })
            }else{
                
                setManttoData((prevState)=>{
                    return {
                        ...prevState,
                        [name]:0
                    }
                    
                })
            }
            
        }  else if(e.target.name==="criticality"){
            setManttoData((prevState)=>{
                return {
                    ...prevState,
                    [name]:value===""?0:(parseInt(value))
                }
                
            })
        }  else if(e.target.name==="status"){
            setManttoData((prevState)=>{
                return {
                    ...prevState,
                    [name]:(value=="Inactivo")?capitalizeFirstLetter(lang[languaje]['activo']):capitalizeFirstLetter(lang[languaje]['inactivo'])
                }
                
            })
        }else{
            setManttoData((prevState)=>{
                return {
                    ...prevState,
                    [name]:value
                }
                
            })
        }
            
          
       
        if(e.target.name==="ip"){
            if(value==""){
                setHostLocation("")
                setHostActivate(0)
                setIpValid(true)
                sethost([])
                setHostName("")
                setHostLocation("")
            }else{
                setIpValid(validateIp(value))
            }
           
           
          }

        
        
      }

      useEffect(()=>{
       
            if( (IpValid==false || ManttoData.tech_name=="" || ManttoData.sla_hours==0 ||ManttoData.sla_hours=="")    ){
              
                setDisabled(true)
            }else{
               
                setDisabled(false)
            }
      },[ManttoData])

      
      const Registrar=()=>{
        
        let method='POST'
        let url_add=''
       
        if(editActive){
            method='PUT'
            url_add=dataTech.cassia_tech_id 
           
        }
     
        
        setLoading(true)
          const fetchDataPost = async () => {
            
         try {
            
              const response = await fetch(server.url+'/api/v1/cassia/services/techs/'+url_add, {
                method: method,  
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem('access_token')}`,
                  },
                body: JSON.stringify(ManttoData),
              });
          
              if (response.ok) {
                
                const data1 = await response.json();
                setLoading(false)
                // Manejo de la respuesta
                setData(data1)
                // console.log(data1);
                closCreateTechModal()
              setRegisterIsValid(true)
              
              const timer = setTimeout(() => {
                setRegisterIsValid(false)
                setEditActive(false)
                // closCreateTechModal()
              }, 3000);
            
              } else {
                throw new Error('Error en la solicitud');
              }
            } catch (error) {
                setHostName("")
                setManttoData({ip:"",host_id:0,date:"",responsible_name:"",auth_name:"",device_description:"",justification:"",previous_state:"",new_state:"",impact:"",result:"",observations:"",files:[],status:'Activo'})
                
            setLoading(false)
              // Manejo de errores
              setError(error)
              closCreateTechModal()
              setRegisterIsValid(true)
              
              const timer = setTimeout(() => {
                setRegisterIsValid(false)
                setEditActive(false)
                closCreateTechModal()
              }, 3000);
              console.error(error);
            }
          };
      
          fetchDataPost();
          
    }
   
    const buscar_host=(ip)=>{
  
        
        setLoadingM(true)
          const fetchDataPost = async () => {
            
         try {
           const response = await fetch(server.url+'/api/v1/cassia/ci_elements/search_host/'+ip, {
                method: 'GET',  
                headers: {
                  'Content-Type': 'application/json',
                  'accept': 'application/json',
                  'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
                },
              });
           
              if (response.ok) {
                
                const data1 = await response.json();
                setLoadingM(false)
                if(data1.data.length==0){
                    sethost([])
                setHostName("")
                setHostLocation("")
                setHostActivate(0)
                    setMsgError(lang[languaje]['msgIpNoExiste'])
                    setIpValid(false)
                }else{
                    setIpValid(true)

                }
                sethost(data1.data)
                setDisabled(true)
              } else {
                const data1 = await response.json();
               
                throw new Error('Error en la solicitud');
              }
            } catch (error) {
              console.error(error);
            }
          };
      
          fetchDataPost();
        
    }
    const changeOption=(option,index)=>{
        
       
        setManttoData((prevState)=>{
            return {
                ...prevState,
                ['cassia_criticality_id']:option.value===""?0:(parseInt(option.value))
            }
            
        })
        // setManttoRelation(option.value)
            
    }
   
    const validateIp= (ip) => {
       
        const ipRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
        let result = ipRegex.test(ip);
        if(result){
            buscar_host(ip)
        }else{
            setHostLocation("")
            setMsgError(lang[languaje]['ipNoValida'])
            sethost([])
                setHostName("")
                setHostLocation("")
                setHostActivate(0)
        }
        return result;
      };
     
   
  const handleKeyPress = (e) => {
    // Permitir solo números, teclas de control y el punto decimal
    const charCode = e.charCode;
    if (
      (charCode >= 48 && charCode <= 57) || // Números 0-9
      charCode === 46 || // Punto decimal
      charCode === 8 || // Retroceso
      charCode === 37 || // Flecha izquierda
      charCode === 39 // Flecha derecha
    ) {
      return;
    } else {
      e.preventDefault();
    }
  };

  const handlePaste = (e) => {
    const paste = (e.clipboardData || window.clipboardData).getData('text');
    if (!/^-?\d*\.?\d*$/.test(paste)) {
      e.preventDefault();
    }
  };
   
    const closeListSearch=()=>{
        setListSearchIP(false)
    }
    const {tech_name,cassia_criticality_id,tech_description,sla_hours}=ManttoData;
    return(
        <div className="modal-GS-content">
            <div className='card-modal-gs modal-verificate'>
                <div className='head-card-modal-gs'>
                    <div className='title-head-card-modal-gs'>
                        {((editActive)?lang[languaje]['editar'].toUpperCase():lang[languaje]['crear'].toUpperCase())+' '+lang[languaje]['tecnologia'].toUpperCase()}
                    </div>
                </div>
                <div className='content-card-modal-gs' style={{overflowY: 'scroll',scrollbarWidth: 'thin'}}>
                
                                    <div className="form-GS-box"> 
                                    
                                    <div className="user-box-GS" style={{height:'20%'}}>
                                        
                                    
                                    <input required name="tech_name"   type="text" value={tech_name}
                                    onChange={handleChange} />
                                   
                                        <label className='label-GS'>{lang[languaje]['nombreTecnologia']}</label>
                                        {
                                            IpValid?'':<span  className='form-msg-error'> {msgError}</span>
                                        }
                                        
                                    </div>
                                    
                                   
                                    <div className="user-box-GS" style={{height:'20%'}}>
                                        {
                                            (dataCriticalities.loading)?'. . .':
                                            <SelectorAdmin placeholder={'Seleccionar agencia...'} opGeneral={true} txtOpGen={'N/A'}  opt_de={cassia_criticality_id} origen={'Admin'} data={dataCriticalities.data.data} loading={dataCriticalities.loading}  titulo='Severity' selectFunction={changeOption} index={0}></SelectorAdmin>

                                        }
                                        <label className='label-GS'>{capitalizeFirstLetter(lang[languaje]['severidad'])}</label> 
                                        {
                                            // (name==="" || nombreIsValid)?'':<span className='form-msg-error'> Nombre no valido</span>
                                        }
                                        
                                    </div>
                                    <div className="user-box-GS" style={{height:'20%'}}>
                                    <input required name="sla_hours" style={{height:'20%'}}  min="0" type="number" value={sla_hours}
                                    onChange={handleChange} onKeyPress={handleKeyPress} 
                                    onPaste={handlePaste}    />
                                        <label className='label-GS '>No. {capitalizeFirstLetter(lang[languaje]['horas'])} SLA</label>
                                        {
                                            // (name==="" || nombreIsValid)?'':<span className='form-msg-error'> Nombre no valido</span>
                                        }
                                        
                                    </div>
                                    <div className="user-box-GS" style={{height:'20%'}}>
                                    <input required name="tech_description" style={{height:'20%'}}  type="text" value={tech_description}
                                    onChange={handleChange} />
                                        <label className='label-GS'>{capitalizeFirstLetter(lang[languaje]['descripcion'])}</label>
                                        {
                                            // (name==="" || nombreIsValid)?'':<span className='form-msg-error'> Nombre no valido</span>
                                        }
                                        
                                    </div>
                                   
                                
                                    
                                    <div className="user-box-GS" style={{height:'20%'}}>
                                        {
                                            (loading)?<LoadSimple></LoadSimple>
                                            :
                                            <>
                                            <Action disabled={false} origen='Cancelar' titulo={capitalizeFirstLetter(lang[languaje]['cancelar'])}  action={closCreateTechModal}/>
                                            <Action disabled={disabled} origen='Azul' titulo={capitalizeFirstLetter(lang[languaje]['guardar'])}  action={Registrar}/>
                                            </>
                                        }
                                            
                                    {
                                        // (registerIsValid && data.message!=="User deleted successfully")?<span className='form-msg-ok'>Usuario registrado correctamente</span>:''
                                    }
                                        
                                    </div>
                                </div>
                </div>
                </div>
        </div>
    )
}

export default ModalCreateTech